
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useToast } from "primevue/usetoast";
import router from "@/router";

export default {
  props: {
    isLoggedIn: {
      type: Boolean,
      required: true
    }
  },
  setup(props) {
    const store = useStore();
    const toast = useToast();
    const userMenu = [
      {
        label:'TRUNG TÂM Y TẾ HUYỆN HÒA VANG',
     icon:'pi pi-fw pi-list',
        url: '/'
      }
    ];
    const adminMenu = [
      {
        label:'Xem lịch',
        icon:'pi pi-fw pi-calendar',
        url: '/'
      },
      {
        label:'Thống kê',
        icon:'pi pi-fw pi-chart-bar',
        url: '/statistical'
      },
      {
        label:'Danh sách tái khám',
        icon:'pi pi-fw pi-list',
        url: '/reExamination'
      },
      {
        label:'Tìm kiếm',
        icon:'pi pi-fw pi-search',
        url: '/searchbook'
      },
      {
        label:'Cấu hình',
        icon:'pi pi-fw pi-cog',
        url: '/config'
      },
      {
        label:'Mật khẩu',
        icon:'pi pi-fw pi-key',
        url: '/password'
      },
      {
        label:'Đăng ký',
        icon:'pi pi-fw pi-user-plus',
        url: '/register'
      },
      {
        label:'Quản lý',
        icon:'pi pi-fw pi-users',
        url: '/users'
      },
    ];

    const defaultMenu = [
      {
        label:'Xem lịch',
        icon:'pi pi-fw pi-calendar',
        url: '/'
      },
      {
        label:'Thống kê',
        icon:'pi pi-fw pi-list',
        url: '/statistical'
      },
      {
        label:'Mật khẩu',
        icon:'pi pi-fw pi-key',
        url: '/password'
      },
    ];
    const appMenu = computed(() => {
      if(props.isLoggedIn)
      {
        if(store.state.permission == "admin") return adminMenu;
        else return defaultMenu;
      }
      else
      {
        return userMenu;
      }
    });
    const logout = () => {
      store.dispatch('clearToken');
      store.dispatch('clearPermission');
      store.dispatch('clearTeam');
      router.push({
        name: 'home',
      });
      toast.add({
        severity:'success',
        summary: 'Đăng xuất',
        detail:'Đã xóa thông tin đăng nhập thành công',
        life: 1000
      });
    }

    return {
      appMenu,
      logout
    }
  }
}
